import React, { useEffect, useRef, useState } from "react";
import { Spin, Select, Checkbox, Form, Button, Table, Modal, notification, Radio } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getGenderCategory } from "../../redux/actions/genderCategory.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getGender } from "../../redux/actions/gender.action";
import { ReadCookie } from "../../utils/readCookie";
import { getStyle, getStyleChangeNew } from "../../redux/actions/style";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo-black.svg";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import "../Distributor/Distributor.css";
import { useHistory } from "react-router-dom";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import { getFitCategory, getFitChange } from "../../redux/actions/fitCategory.action";
import { getAmazonProductUploaderDetailsPants, getAmazonProductUploaderNew, getSYNCAmazonProduct } from "../../redux/actions/amazonProductInformation.action";
import Loader from "react-spinners/BarLoader";
import { getProductType } from "../../redux/actions/productType.action";
import { getSize } from "../../redux/actions/size.action";
import { getWashChange, getWashName } from "../../redux/actions/wash.action";
import { Axios } from "axios";
import "../AmazonProductUploader/amazonProductUploader.css"

const AmazonProductUploaderNew = ({ token }) => {
  TabTitle("Amazon-product")
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    productStatus,
    gender,
    style,
    styleChange,
    wash,
    washChange,
    fitCategory,
    fitChange,
    amazonProductUploaderNew
  } = useSelector((state) => state);
  const history = useHistory();
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([])
  const [excelData, setExcelData] = useState([])
  const [selectedStatuses, setSelectedStatuses] = useState([3]);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { Option } = Select;
  const [parentItemCode, setParentItemCode] = useState(null);
  const [syncButtonLoader, SetSyncButtonLoader] = useState(false)

  const handleAllChange = (e) => {
    if (e.target.checked) {
      setAllSelected(true);
      setSelectedStatuses([]);
    }
  };

  const handleStatusChange = (id, checked) => {
    let updated = [...selectedStatuses];

    if (checked) {
      updated.push(id);
    } else {
      updated = updated.filter(item => item !== id);
    }
    setSelectedStatuses(updated);

    if (updated.length === 0) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  };



  const onFinish = async (e) => {
    setLoading(true)
    setSelectedRows([])
    setParentItemCode(null)
    await form.validateFields().then((values) => {
      const formData = {
        ...values,
        product_status: allSelected ? null : selectedStatuses.join(","),
      }
      dispatch(getAmazonProductUploaderNew(token, formData)).then((res => {
        setLoading(false)
        setData(res?.payload?.data)
        downloadExcelFileData(res?.payload?.data);
      }));
    });
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows);
    },
  };


  function downloadExcelFileData(data) {
    if (data?.length > 0) {
      setExcelData(
        data.map((v) => {
          return {
            "Gender": v.gender_name,
            "Gender Category": v.gender_category_name,
            "Product Type": v.product_type_name,
            "Fit Category": v.fit_category_name,
            "Style": v.style_name,
            "Wash": v.wash_name,
            "Fabric": v.fabric_name,
            "Rise": v.rise_label_name,
            "Current Season": v.newseason_name,
            "Current Season Year": v.season_year,
            "SKU": v.sku_inseam,
            "Bergen": v.bergan,
          };
        })
      )
    }
  }


  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(getProductType(token));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getProductStatus(token, menuId));
    dispatch(getSize(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getFitCategory(token, menuId));
    dispatch(getWashName(token, menuId));
  }, [dispatch, menuId, token]);



  const handlePrint = () => {
    const css = '@page { margin-top: 8px; margin-bottom: 8px;  size: landscape;  }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };


  const columns = [
    {
      title: "S#",
      align: "center",
      width: "60px",
      sorter: (a, b) => 0,
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      sorter: (a, b) => {
        if ((a.gender_name !== null) & (b.gender_name !== null)) {
          return a.gender_name.localeCompare(b.gender_name);
        }
      },
    },
    {
      title: "Gender Category",
      dataIndex: "gender_category_name",
      key: "gender_category_name",
      sorter: (a, b) => {
        if ((a.gender_category_name !== null) & (b.gender_category_name !== null)) {
          return a.gender_category_name.localeCompare(b.gender_category_name);
        }
      },
    },
    {
      title: "Product Type",
      dataIndex: "product_type_name",
      key: "product_type_name",
      sorter: (a, b) => {
        if ((a.product_type_name !== null) & (b.product_type_name !== null)) {
          return a.product_type_name.localeCompare(b.product_type_name);
        }
      },
    },
    {
      title: "Fit Category",
      dataIndex: "fit_category_name",
      key: "fit_category_name",
      sorter: (a, b) => {
        if ((a.fit_category_name !== null) & (b.fit_category_name !== null)) {
          return a.fit_category_name.localeCompare(b.fit_category_name);
        }
      },
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      sorter: (a, b) => {
        if ((a.style_name !== null) & (b.style_name !== null)) {
          return a.style_name.localeCompare(b.style_name);
        }
      },
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      sorter: (a, b) => {
        if ((a.wash_name !== null) & (b.wash_name !== null)) {
          return a.wash_name.localeCompare(b.wash_name);
        }
      },
    },

    {
      title: "Fabric",
      dataIndex: "fabric_name",
      key: "fabric_name",
      sorter: (a, b) => {
        if ((a.fabric_name !== null) & (b.fabric_name !== null)) {
          return a.fabric_name.localeCompare(b.fabric_name);
        }
      },
    },
    {
      title: "Rise",
      dataIndex: "rise_label_name",
      key: "rise_label_name",
      sorter: (a, b) => {
        if ((a.rise_label_name !== null) & (b.rise_label_name !== null)) {
          return a.rise_label_name.localeCompare(b.rise_label_name);
        }
      },
    },
    {
      title: "C. Season",
      dataIndex: "newseason_name",
      key: "newseason_name",
      sorter: (a, b) => {
        if ((a.newseason_name !== null) & (b.newseason_name !== null)) {
          return a.newseason_name.localeCompare(b.newseason_name);
        }
      },
    },
    {
      title: "C. Season Year",
      dataIndex: "season_year",
      key: "season_year",
      sorter: (a, b) => {
        if ((a.season_year !== null) & (b.season_year !== null)) {
          return a.season_year.localeCompare(b.season_year);
        }
      },
    },
    {
      title: "SKU",
      dataIndex: "sku_inseam",
      key: "sku_inseam",
      sorter: (a, b) => {
        if ((a.sku_inseam !== null) & (b.sku_inseam !== null)) {
          return a.sku_inseam.localeCompare(b.sku_inseam);
        }
      },
    },
    {
      title: "Bergen",
      dataIndex: "bergan",
      key: "bergan",
      align: "right",
      sorter: (a, b) => {
        if ((a.bergan !== null) & (b.bergan !== null)) {
          return a.bergan - b.bergan;
        }
      },
    },
    {
      title: "Parent",
      align: "center",
      sorter: (a, b) => 0,
      render: (_, record) => (
        <Radio value={record?.sku_inseam} />
      ),
    }
  ];

  const handleButtonClick = () => {
    setIsModalVisible(true);
  };




  const handleConfirm = () => {
    setIsModalVisible(false);
    setButtonLoading(true);

    const skuInseam = selectedRows
      .map(row => row?.sku_inseam)
      .filter(Boolean);

    const filterParentItemId = data?.find(
      (x) => x.sku_inseam === parentItemCode
    );

    dispatch(
      getAmazonProductUploaderDetailsPants(
        token,
        filterParentItemId?.item_id,
        skuInseam
      )
    )
      .then(async (response) => {
        console.log(response);

        const { success, message, data } = response?.payload || {};

        if (!success) {
          notification.error({
            message: "Error",
            description: message || "Something went wrong!",
          });
          return;
        }

        const s3Url = data?.s3Url;
        console.log("S3 URL:", s3Url);

        if (!s3Url || typeof s3Url !== "string") {
          throw new Error("S3 URL not found in response");
        }

        // ✅ Download file from S3
        const fileResponse = await fetch(s3Url);
        const blob = await fileResponse.blob();

        const excelUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = excelUrl;
        const fileExtension = s3Url.split('.').pop().split('?')[0];
        link.download = `Amazon_Product.${fileExtension}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(excelUrl);

        // ✅ API ka message show karega
        notification.success({
          message: "Success",
          description: message || "Excel downloaded successfully!",
        });

        setSelectedRows([]);
        setParentItemCode(null)
        onFinish();
      })
      .catch((error) => {
        console.error("API call error:", error);

        notification.error({
          message: "Error",
          description: "Something went wrong while downloading Excel!",
        });
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };




  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleGender = (gender_id) => {
    dispatch(getFitChange(token, gender_id, null));
    dispatch(getStyleChangeNew(token, gender_id, null));
    dispatch(getWashChange(token, gender_id, null, null));
    form.setFieldsValue({
      style_id: "All",
      wash_id: ["All"],
      fit_id: "All"
    })
  }

  const handleStyle = (fit_category_id) => {
    dispatch(getStyleChangeNew(token, form.getFieldValue().gender_id, fit_category_id))
    dispatch(getWashChange(token, form.getFieldValue().gender_id, fit_category_id, null));
    form.setFieldsValue({
      style_id: "All",
      wash_id: ["All"],
    })
  }

  const handleWash = (style_id) => {
    dispatch(getWashChange(token, form.getFieldValue().gender_id, form.getFieldValue().fit_id, style_id));
    form.setFieldsValue({
      wash_id: ["All"],
    })
  }

  const columnsStyles = [
    {
      title: "",
      dataIndex: "style_id",
      width: 60,
      align: "center",
      render: (value) => (
        <Radio value={value} />
      ),
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      sorter: (a, b) => {
        if ((a.style_name !== null) & (b.style_name !== null)) {
          return a.style_name.localeCompare(b.style_name);
        }
      },
    },
    {
      title: "No of SKU",
      dataIndex: "total_rows",
      key: "total_rows",
      align: "right",
      sorter: (a, b) => {
        if ((a.total_rows !== null) & (b.total_rows !== null)) {
          return a.total_rows - b.total_rows;
        }
      },
    },
    {
      title: "Total Bergan",
      dataIndex: "bergan",
      key: "bergan",
      align: "right",
      sorter: (a, b) => {
        if ((a.bergan !== null) & (b.bergan !== null)) {
          return a.bergan - b.bergan;
        }
      },
    },
  ];


  // Add this handler for wash_id
  const handleWashChange = (value) => {
    if (value.length === 0) {
      // If list is empty, auto-select "All"
      setTimeout(() => {
        form.setFieldsValue({ wash_id: ["All"] });
      }, 0);
      return;
    }

    const lastSelected = value[value.length - 1];

    if (lastSelected === "All") {
      // User selected "All", so remove all others
      setTimeout(() => {
        form.setFieldsValue({ wash_id: ["All"] });
      }, 0);
    } else {
      // User selected something else — remove "All"
      const filtered = value.filter((v) => v !== "All");
      setTimeout(() => {
        form.setFieldsValue({ wash_id: filtered });
      }, 0);
    }
  };

  const handleClear = () => {
    form.setFieldsValue({
      gender_id: "All",
      fit_id: "All",
      style_id: "All",
      wash_id: ["All"],
    })
    setSelectedStatuses([3])
  };


  const handleSyncProduct = () => {
    SetSyncButtonLoader(true);

    dispatch(getSYNCAmazonProduct(token))
      .then((res) => {
        SetSyncButtonLoader(false);

        const payload = res?.payload;
        const stats = payload?.data;

        if (payload?.success) {
          notification.success({
            message: payload?.message,
            description: (
              <div>
                <div>Total Products: <b>{stats?.totalProducts}</b></div>
                <div>Updated: <b>{stats?.estimatedUpdated}</b></div>
                <div>Duration: <b>{stats?.duration}</b></div>
              </div>
            ),
            duration: 4,
          });
        } else {
          notification.error({
            message: payload?.message || "Amazon Product Sync Failed",
          });
        }
      })
      .catch(() => {
        SetSyncButtonLoader(false);
        notification.error({
          message: "Error",
          description: "API error occurred during sync.",
        });
      });
  };




  return (
    <div className="header_class business_header_oms print-container">
      <div className="row justify-content-between business_class_oms distributor distributor_amazon">
        <div className="col-3 d-flex align-items-start box-space">
          {/* <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div> */}
        </div>
        {/* <div className="col-sm-6 box-space pl-sm-0">
                    <div className="brand-para">
                        <div>DL1961 Premium Denim Inc.</div>
                        <div>121 Varick Street</div>
                        <div>4th Floor</div>
                        <div>New York, NY 10013</div>
                        <div>(P) 646-514-9736</div>
                        <div>(F) 212-991-9989</div>
                        <div>(E) sales@DL1961.com</div>
                    </div>
                </div> */}
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8 printing_class">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class">
                <CSVLink
                  filename={"amazon-product.csv"}
                  data={excelData}
                  style={{ display: "flex" }}
                  onClick={() => {
                  }}
                >
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    style={{ borderWidth: "0px", height: "14px" }}
                  // onClick={handleExcelExport}
                  />
                </CSVLink>
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Amazon Product
              <br />
              {/* Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p> */}
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
              {/* <br /> */}
            </span>
          </div>
        </div>
      </div>
      <div className="business_class_oms distributor distributor_amazon">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-2" />
              <div className="d-flex justify-content-between">
                <div>
                  <label htmlFor="">Product Status</label>
                  <div className="checkboxes">
                    <div className="checkbox_content">
                      <Form.Item name="current_status_id" className=" mb-0">
                        <Checkbox checked={allSelected} onChange={handleAllChange} className="amazon-product-uploader-checkbox">
                          All
                        </Checkbox>
                      </Form.Item>
                    </div>
                    {productStatus &&
                      productStatus?.payload?.data.map((it, index) => {
                        return (
                          <div key={index} className="checkbox_content">
                            <Form.Item name="current_status_id">
                              <Checkbox
                                className="amazon-product-uploader-checkbox"
                                key={it.product_status_id}
                                checked={selectedStatuses.includes(it.product_status_id)}
                                onChange={(e) =>
                                  handleStatusChange(it.product_status_id, e.target.checked)
                                }
                              >
                                {it.product_status_name}
                              </Checkbox>
                            </Form.Item>
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-center justify-content-end">
                  <Button
                    style={{ width: "fit-content" }}
                    type="primary"
                    // htmlType="submit"
                    className="submit-btn-btm m-0 amazon-product-uploader-generate-btn btn-width"
                    onClick={handleSyncProduct}
                  >
                    {syncButtonLoader ? (
                      <Spin size="small" className="customer_payment_ledger_btn_loader mr-1" />
                    ) : (
                      'Sync Amazon Product'
                    )}

                  </Button>
                </div>
              </div>
              <hr className="my-2 mb-3" />
              <div className="main_form row">
                <div className="col-12 col-xl-4 col-md-4 mb-2">
                  <div className=" d-flex flex-column align-items-baseline amazon-product-uploader-input">
                    <label className="labels width44" htmlFor="">Gender</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="gender_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleGender(e)}
                        >
                          <Option value="All">All</Option>
                          {gender &&
                            gender?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.gender_id}>
                                  {it.gender_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-4 col-md-4 mb-2">
                  <div className=" d-flex flex-column align-items-baseline amazon-product-uploader-input">
                    <label className="labels width44" htmlFor="">Fit Category</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="fit_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleStyle(e)}
                        >
                          <Option value="All">All</Option>
                          {
                            fitChange &&
                              fitChange?.payload?.data.length >= 0 ? (
                              fitChange &&
                              fitChange?.payload?.data?.slice()?.sort((a, b) => a.fit_category_name.toLowerCase().localeCompare(b.fit_category_name.toLowerCase()))?.map((it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.fit_category_id}
                                  >
                                    {it.fit_category_name}
                                  </Option>
                                );
                              })
                            ) : (
                              fitCategory &&
                              fitCategory?.payload?.data?.slice()?.sort((a, b) => a.fit_category_name.toLowerCase().localeCompare(b.fit_category_name.toLowerCase()))?.map((item, index) => {
                                return <Option key={item.fit_category_id} value={item.fit_category_id}>{item.fit_category_name}</Option>
                              }
                              )
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-4 col-md-4 mb-2">
                  <div className=" d-flex flex-column align-items-baseline amazon-product-uploader-input">
                    <label className="labels width44" htmlFor="">Style</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="style_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleWash(e)}
                        >
                          <Option value="All">All</Option>
                          {
                            styleChange && styleChange?.payload?.data.length >= 0 ? (
                              styleChange && styleChange?.payload?.data?.slice()?.sort((a, b) => a.style_name.toLowerCase().localeCompare(b.style_name.toLowerCase()))?.map((style, index) => {
                                return (
                                  <Option key={index} value={style.style_id}>
                                    {style.style_name}
                                  </Option>
                                );
                              })
                            ) : (
                              style && style?.payload?.data?.slice()?.sort((a, b) => a.style_name.toLowerCase().localeCompare(b.style_name.toLowerCase()))?.map((style, index) => {
                                return (
                                  <Option key={index} value={style.style_id}>
                                    {style.style_name}
                                  </Option>
                                );
                              })
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-8 col-md-4 mb-2">
                  <div className=" d-flex flex-column align-items-baseline amazon-product-uploader-input">
                    <label className="labels width44" htmlFor="">Wash</label>
                    <div className="w-100 fit-selectbox-width amazon-selectbox">
                      <Form.Item name="wash_id"
                        initialValue={["All"]}
                      >
                        <Select
                          // defaultValue={form.getFieldValue().wash_id}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          mode="multiple"
                          onChange={handleWashChange}
                          value={form.getFieldValue('wash_id')}
                        >
                          <Option value="All">All</Option>
                          {
                            washChange &&
                              washChange?.payload?.data.length >= 0 ? (
                              washChange &&
                              washChange?.payload?.data?.slice()?.sort((a, b) => a.wash_name.toLowerCase().localeCompare(b.wash_name.toLowerCase()))?.map((it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.wash_id}
                                  >
                                    {it.wash_name}
                                  </Option>
                                );
                              })
                            ) : (
                              wash &&
                              wash?.payload?.data?.slice()?.sort((a, b) => a.wash_name.toLowerCase().localeCompare(b.wash_name.toLowerCase()))?.map((status, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={status.wash_id}
                                  >
                                    {status.wash_name}
                                  </Option>
                                );
                              }
                              )
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-4 d-flex justify-content-between align-items-end" style={{ height: '55px' }}>
                  <div className=" d-flex flex-column align-items-baseline justify-content-start " >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        // marginTop: "3px",
                        float: "right",
                        gap: "10px",

                      }}
                    >
                      <Button
                        style={{ width: "fit-content" }}
                        type="primary"
                        htmlType="submit"
                        className="submit-btn-btm m-0 amazon-product-uploader-generate-btn"
                      >
                        Search
                      </Button>
                      <Button
                        style={{ width: "fit-content" }}
                        type="primary"
                        // htmlType="submit"
                        className="submit-btn-btm m-0 amazon-product-uploader-generate-btn amazon-cancel-btn"
                        onClick={handleClear}
                      >
                        Clear
                      </Button>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end align-items-center justify-content-end">
                    {/* {
                      selectedRows?.length > 0 && (
                        <div className="mx-2" style={{ fontSize: '11px' }}>Selected {selectedRows.length}{" "}{selectedRows.length === 1 ? "product" : "products"} </div>)
                    } */}
                    <Button
                      type="primary"
                      className="submit-btn-btm m-0 amazon-product-uploader-generate-btn btn-width"
                      onClick={handleButtonClick}
                      disabled={buttonLoading || !selectedRows.length || !parentItemCode}
                    >
                      {buttonLoading ? (
                        <Spin size="small" className="customer_payment_ledger_btn_loader mr-1" />
                      ) : (
                        'Generate Template'
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className="table_content international_order table_content_amazon table_content_amazon_new"
      // style={{ maxWidth: '1600px' }}
      >
        {
          selectedRows?.length > 0 && (
            <div className="mx-2 d-flex justify-content-end mb-2" style={{ fontSize: '14px' }}>Selected {selectedRows.length}{" "}{selectedRows.length === 1 ? "product" : "products"} </div>)
        }
        <div>
          {amazonProductUploaderNew?.payload?.data !== undefined ?
            (
              data?.length > 0 ? (
                <Radio.Group
                  value={parentItemCode}
                  onChange={(e) => setParentItemCode(e.target.value)}
                  style={{ width: "100%" }}
                >
                  <Table
                    className="bottom-align-th th-general-style td-general-style border prod-table omsTable amazon-product-uploader-table"
                    ref={tableRef}
                    size="small"
                    bordered={false}
                    type="company"
                    dataSource={data || []}
                    columns={columns}
                    scroll={{ x: 'max-content' }}
                    loading={amazonProductUploaderNew?.loading}
                    pagination={{
                      defaultCurrent: 1,
                      defaultPageSize: 100,
                      pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                    }}
                    rowSelection={{
                      ...rowSelection,
                      hideSelectAll: true,
                    }}
                    rowKey="sku_inseam"
                  />
                </Radio.Group>
              ) : (
                // null
                <div className="no-Data">
                  <h1>No Data</h1>
                </div>

              )
            ) : (
              loading && (
                <div className="loader" style={{ marginTop: "20px" }}>
                  <Spin size="medium" />
                </div>
              )
            )
          }
        </div>
      </div>
      <Modal
        title="Confirm Action"
        visible={isModalVisible}
        onOk={handleConfirm}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="No"
        okButtonProps={{ style: { backgroundColor: 'black', borderColor: 'black', color: 'white' } }}
      >
        Are you sure you want to generate?
      </Modal>

    </div>
  );
};

export default AmazonProductUploaderNew;
